import { useSearchParams } from "react-router-dom";

export default function URLPreview({ url }: { url: string }) {
  const [_, setSearchParams] = useSearchParams();

  if (!url) return null;

  return (
    <span
      className="text-primary cursor-pointer ml-2 text-underline--hover"
      onClick={() => {
        setSearchParams((params) => {
          params.set("w", url);
          return params;
        });
      }}
    >
      Preview
      <i className="ml-1 mdi mdi-open-in-new"></i>
    </span>
  );
}
